module.exports = __webpack_public_path__ + "static/media/white.30e41b49.svg";